"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Recommend = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = require("react-helmet");

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactRedux = require("react-redux");

var _reactRouterRedux = require("react-router-redux");

var _reduxForm = require("redux-form");

var _recommendValidator = require("./recommendValidator");

var _recommendValidator2 = _interopRequireDefault(_recommendValidator);

var _RecommendForm = require("../../components/recommend/RecommendForm");

var _RecommendForm2 = _interopRequireDefault(_RecommendForm);

var _RecommendSuccessPanel = require("../../components/recommend/RecommendSuccessPanel");

var _RecommendSuccessPanel2 = _interopRequireDefault(_RecommendSuccessPanel);

var _recommend = require("../../redux/modules/recommend");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Recommend = exports.Recommend = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(Recommend, _Component);

  function Recommend() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Recommend);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Recommend.__proto__ || (0, _getPrototypeOf2.default)(Recommend)).call.apply(_ref, [this].concat(args))), _this), _this.submit = function (values) {
      _this.props.sendRecommendation(values);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Recommend, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        { className: "container" },
        _react2.default.createElement(_reactHelmet2.default, { title: "Kerro kaverille" }),
        _react2.default.createElement(
          "div",
          null,
          this.defineContent()
        )
      );
    }
  }, {
    key: "defineContent",
    value: function defineContent() {
      if (this.props.recommend.sendRecommendationSuccess) {
        return _react2.default.createElement(_RecommendSuccessPanel2.default, {
          pushRoute: this.props.pushRoute,
          resetState: this.props.resetRecommendation
        });
      }

      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(_RecommendForm2.default, {
          fields: this.props.fields,
          handleSubmit: this.props.handleSubmit,
          recommend: this.props.recommend,
          onSubmit: this.submit
        })
      );
    }
  }]);
  return Recommend;
}(_react.Component), _class.propTypes = {
  pushRoute: _react.PropTypes.func.isRequired,
  sendRecommendation: _react.PropTypes.func.isRequired,
  resetRecommendation: _react.PropTypes.func.isRequired,
  recommend: _react.PropTypes.object.isRequired,
  fields: _react.PropTypes.object.isRequired,
  handleSubmit: _react.PropTypes.func.isRequired
}, _temp2);
exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    recommend: state.recommend
  };
}, {
  sendRecommendation: _recommend.sendRecommendation,
  pushRoute: _reactRouterRedux.push,
  resetRecommendation: _recommend.resetRecommendation
})((0, _reduxForm.reduxForm)({
  form: "recommend",
  fields: ["name", "phone", "email"],
  validate: _recommendValidator2.default
})(Recommend));


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Recommend/Recommend.js
 ** module id = 1237
 ** module chunks = 0
 **/